import React, { memo, useCallback, useEffect, useState } from "react";
import moment from "moment";
import api from "APP_ROOT/api";
import { properCase } from "LIB/formatters/text";
import { Col, Row } from "react-bootstrap";
import StatsPanel from "MODULES/Admin/CompanyRankings/StatsPanel";
import SimpleDateRangePicker from "MODULES/Admin/CompanyRankings/SimpleDateRangePicker";
import { MONTHS } from "APP_ROOT/constants";

function CompanyRankings({ endDate, startDate }) {
  const [isLoading, setIsLoading] = useState(true);
  const [results, setResults] = useState({});

  const performRequest = useCallback(
    () => {
      api.companies.rankingStats({ endDate, startDate }).then(({ data }) => {
        setResults(data);
        setIsLoading(false);
      });
    },
    [endDate, startDate]
  );

  useEffect(
    () => {
      performRequest();
    },
    [endDate, startDate]
  );

  if (isLoading) return null;
  return (
    <div>
      <Row>
        <StatsPanel
          title={properCase("purchased_by_us")}
          results={results.purchased_by_us}
        />

        <StatsPanel
          title={properCase("sold_by_us")}
          results={results.sold_by_us}
        />
      </Row>
      <Row>
        <StatsPanel
          title={properCase("repairs_sent")}
          results={results.repairs_sent}
        />
        <StatsPanel
          title={properCase("sold_by_company_type")}
          results={results.sales_by_company_type}
        />
      </Row>
      <Row>
        <StatsPanel
          title={properCase("sold_by_region")}
          label="Region"
          results={results.sold_by_region}
        />
        <StatsPanel
          title={properCase("sold_by_country")}
          results={results.sales_by_country}
        />
      </Row>
    </div>
  );
}

const Report = memo(() => {
  const [startDate, setStartDate] = useState(
    moment()
      .subtract(12, MONTHS)
      .toDate()
  );
  const [endDate, setEndDate] = useState(moment().toDate());

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <Col>
      <Row>
        <Col md={12}>
          <div
            className="header-content"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <h1>
              Company Rankings &nbsp;<span style={{ marginRight: "10px" }}>
                {startDate && `- ${moment(startDate).format("MMMM DD, YYYY")}`}
                {endDate && ` - ${moment(endDate).format("MMMM DD, YYYY")}`}
              </span>
            </h1>
            <div style={{ marginLeft: 20, display: "inline-block" }}>
              <SimpleDateRangePicker handleDateChange={handleDateChange} />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <CompanyRankings endDate={endDate} startDate={startDate} />
      </Row>
    </Col>
  );
});

export default Report;



// WEBPACK FOOTER //
// ./app/modules/Admin/CompanyRankings/CompanyRankings.jsx